import type {
  AvailableTenantDto,
  SessionResponseDtoFrontendUserState,
  SessionTenantDto,
  SessionUserDto,
} from '@/generated/api/models';
import type { AuthPhase } from './auth-machine';

/**
 * Data-only (no actions), so it can be handed straight to the router context.
 * `currentTenant` is what the subdomain resolved to server-side (null if
 * unreachable); `frontendUserState` is the routing decision the `_app` guard switches on.
 */
export interface AuthState {
  phase: AuthPhase;
  isAuthenticated: boolean;
  frontendUserState: SessionResponseDtoFrontendUserState | null;
  user: SessionUserDto | null;
  currentTenant: SessionTenantDto | null;
  availableTenants: AvailableTenantDto[];
}

export const initialAuthState: AuthState = {
  phase: 'initializing',
  isAuthenticated: false,
  frontendUserState: null,
  user: null,
  currentTenant: null,
  availableTenants: [],
};
